import Layout from "@/views/layout/layout";
const rootPath = "/tran";

const transfer = {
  path: rootPath,
  name: "transfer",
  description: "이체",
  redirect: rootPath + "/trsaccInfoInptReq",
  component: Layout,
  children: [
    {
      path: "trsaccInfoInptReq",
      name: "trsaccInfoInptReq",
      redirect: { name: "trsaccInfoInptStep1" },
      component: () => import("@/views/templates/transfer/trsaccInfoInptReq"),
      children: [
        {
          path: "step1",
          name: "trsaccInfoInptStep1",
          description: "당행이체-step1",
          component: () => import("@/views/templates/transfer/trsaccInfoInptReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "trsaccInfoInptStep2",
          description: "당행이체-step2",
          component: () => import("@/views/templates/transfer/trsaccInfoInptReqStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step3",
          name: "trsaccInfoInptStep3",
          description: "당행이체-step3",
          component: () => import("@/views/templates/transfer/trsaccInfoInptReqStep3"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "step4",
          name: "trsaccInfoInptStep4",
          description: "당행이체-step4",
          component: () => import("@/views/templates/transfer/trsaccInfoInptReqStep4"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 4,
            goback: false,
          },
        },
        {
          path: "step5",
          name: "trsaccInfoInptStep5",
          description: "당행이체-step5",
          component: () => import("@/views/templates/transfer/trsaccInfoInptReqStep5"),
          meta: {
            roles: ["login"],
            transparent: true,
            firstPage: "trsaccInfoInptReq",
            step: 5,
          },
        },
        {
          path: "step6",
          name: "trsaccInfoInptStep6",
          description: "당행이체-step6",
          component: () => import("@/views/templates/transfer/trsaccInfoInptReqStep6"),
          meta: {
            roles: ["login"],
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "group",
          name: "trsaccInfoInptReqGrp",
          redirect: { name: "trsaccInfoInptReqGrpUpdat" },
          component: () => import("@/views/templates/transfer/trsaccInfoInptReq"),
          children: [
            {
              path: "updat",
              name: "trsaccInfoInptReqGrpUpdat",
              description: "당행이체-이체그룹수정",
              component: () => import("@/views/templates/transfer/trsaccInfoInptReqGrpUpdat"),
              meta: {
                roles: ["login"],
                step: 1,
              },
            },
            {
              path: "rmkUpdat",
              name: "trsaccInfoInptReqGrpRmkUpdat",
              description: "당행이체-입금정보수정",
              component: () => import("@/views/templates/transfer/trsaccInfoInptReqGrpRmkUpdat"),
              meta: {
                roles: ["login"],
                step: 2,
              },
            },
          ],
        },
        {
          path: "approvalComplete",
          name: "trsaccInfoInptApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "otrbnkTrsaccInfoInptReq",
      name: "otrbnkTrsaccInfoInptReq",
      redirect: { name: "otrbnkTrsaccInfoInptReqStep1" },
      component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReq"),
      children: [
        {
          path: "step1",
          name: "otrbnkTrsaccInfoInptReqStep1",
          description: "타행이체신청-출금 계좌번호",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "otrbnkTrsaccInfoInptReqStep2",
          description: "타행이체신청-입금 계좌번호",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step3",
          name: "otrbnkTrsaccInfoInptReqStep3",
          description: "타행이체신청-이체 메모 입력",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep3"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "step4",
          name: "otrbnkTrsaccInfoInptReqStep4",
          description: "타행이체신청-이체 내용 확인",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep4"),
          meta: {
            roles: "login",
            firstPage: "otrbnkTrsaccInfoInptReqStep1",
            step: 4,
          },
        },
        {
          path: "step5",
          name: "otrbnkTrsaccInfoInptReqStep5",
          description: "타행이체신청-이체 완료 화면",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep5"),
          meta: {
            roles: "login",
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "otrbnkTrsaccInfoInptApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "vtnOtrbnkTrsaccInfoInptReq",
      name: "vtnOtrbnkTrsaccInfoInptReq",
      redirect: { name: "vtnOtrbnkTrsaccInfoInptReqStep1" },
      component: () => import("@/views/templates/transfer/vtnOtrbnkTrsaccInfoInptReq"),
      children: [
        {
          path: "step11",
          name: "vtnOtrbnkTrsaccInfoInptReqStep1",
          description: "타행이체신청-출금 계좌번호",
          component: () => import("@/views/templates/transfer/vtnOtrbnkTrsaccInfoInptReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step21",
          name: "vtnOtrbnkTrsaccInfoInptReqStep2",
          description: "타행이체신청-입금 계좌번호",
          component: () => import("@/views/templates/transfer/vtnOtrbnkTrsaccInfoInptReqStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step3",
          name: "citadOtrbnkTrsaccInfoInptReqStep3",
          description: "타행이체신청-이체 메모 입력",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep3"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "step4",
          name: "citadOtrbnkTrsaccInfoInptReqStep4",
          description: "타행이체신청-이체 내용 확인",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep4"),
          meta: {
            roles: "login",
            firstPage: "otrbnkTrsaccInfoInptReqStep1",
            step: 4,
          },
        },
        {
          path: "step5",
          name: "citadOtrbnkTrsaccInfoInptReqStep5",
          description: "타행이체신청-이체 완료 화면",
          component: () => import("@/views/templates/transfer/otrbnkTrsaccInfoInptReqStep5"),
          meta: {
            roles: "login",
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "step31",
          name: "vtnOtrbnkTrsaccInfoInptReqStep3",
          description: "타행이체신청-이체 메모 입력",
          component: () => import("@/views/templates/transfer/vtnOtrbnkTrsaccInfoInptReqStep3"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "step41",
          name: "vtnOtrbnkTrsaccInfoInptReqStep4",
          description: "타행이체신청-이체 내용 확인",
          component: () => import("@/views/templates/transfer/vtnOtrbnkTrsaccInfoInptReqStep4"),
          meta: {
            roles: "login",
            firstPage: "vtnOtrbnkTrsaccInfoInptReqStep1",
            step: 4,
          },
        },
        {
          path: "step51",
          name: "vtnOtrbnkTrsaccInfoInptReqStep5",
          description: "타행이체신청-이체 완료 화면",
          component: () => import("@/views/templates/transfer/vtnOtrbnkTrsaccInfoInptReqStep5"),
          meta: {
            roles: "login",
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "vtnOtrbnkTrsaccInfoInptApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "autoTrsaccInfoInptReq",
      name: "autoTrsaccInfoInptReq",
      redirect: { name: "autoTrsaccInfoInptReqStep1" },
      component: () => import("@/views/templates/transfer/autoTrsaccInfoInptReq"),
      children: [
        {
          path: "step1",
          name: "autoTrsaccInfoInptReqStep1",
          description: "자동이체등록-step1",
          component: () => import("@/views/templates/transfer/autoTrsaccInfoInptReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
            transparent: true,
          },
        },
        {
          path: "step2",
          name: "autoTrsaccInfoInptReqStep2",
          description: "자동이체등록-step2",
          component: () => import("@/views/templates/transfer/autoTrsaccInfoInptReqStep2"),
          meta: {
            roles: ["login"],
            step: 2,
            transparent: true,
          },
        },
        {
          path: "step3",
          name: "autoTrsaccInfoInptReqStep3",
          description: "자동이체등록-step3",
          component: () => import("@/views/templates/transfer/autoTrsaccInfoInptReqStep3"),
          meta: {
            roles: ["login"],
            step: 3,
            transparent: true,
          },
        },
        {
          path: "step4",
          name: "autoTrsaccInfoInptReqStep4",
          description: "자동이체등록-step4",
          component: () => import("@/views/templates/transfer/autoTrsaccInfoInptReqStep4"),
          meta: {
            roles: ["login"],
            step: 4,
            transparent: true,
          },
        },
        {
          path: "step5",
          name: "autoTrsaccInfoInptReqStep5",
          description: "자동이체등록-step5",
          component: () => import("@/views/templates/transfer/autoTrsaccInfoInptReqStep5"),
          meta: {
            roles: ["login"],
            step: 5,
            transparent: true,
          },
        },
        {
          path: "step6",
          name: "autoTrsaccInfoInptReqStep6",
          description: "자동이체등록-step6",
          component: () => import("@/views/templates/transfer/autoTrsaccInfoInptReqStep6"),
          meta: {
            roles: ["login"],
            step: 6,
            transparent: true,
            firstPage: "autoTrsaccInfoInptReqStep1",
          },
        },
        {
          path: "autoTrsaccInfoInptRes",
          name: "autoTrsaccInfoInptComplete",
          description: "자동이체등록 완료",
          component: () => import("@/views/templates/transfer/autoTrsaccInfoInptRes"),
          meta: {
            roles: ["login"],
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "autoTrsaccInfoInptApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "autoTrsaccHistTermi",
      name: "autoTrsaccHistTermi",
      redirect: { name: "autoTrsaccRegiHist" },
      component: () => import("@/views/templates/transfer/autoTrsaccRegHistTermi"),
      children: [
        {
          path: "autoTrsaccRegiHist",
          name: "autoTrsaccRegiHist",
          description: "자동이체등록-내역조회",
          component: () => import("@/views/templates/transfer/autoTrsaccRegiHist"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "autoTrsaccRegiHistDtl",
          name: "autoTrsaccRegiHistDtl",
          description: "자동이체등록 내역-상세조회",
          component: () => import("@/views/templates/transfer/autoTrsaccRegiHistDtl"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "autoTrsaccTermiReq",
          name: "autoTrsaccRegiHistDtlDelete",
          description: "자동이체등록-해지입력",
          component: () => import("@/views/templates/transfer/autoTrsaccTermiReq"),
          meta: {
            roles: ["login"],
            firstPage: "autoTrsaccRegiHist",
            step: 2,
          },
        },
        {
          path: "autoTrsaccTermiRes",
          name: "autoTrsaccRegiHistDtlComplete",
          description: "자동이체등록-해지완료",
          component: () => import("@/views/templates/transfer/autoTrsaccTermiRes"),
          meta: {
            roles: ["login"],
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "autoTrsaccTermiApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
          },
        },
      ],
    },
    {
      path: "autoTrsaccUpdateReq",
      name: "autoTrsaccUpdateReq",
      redirect: { name: "autoTrsaccUpdateReq1" },
      component: () => import("@/views/templates/transfer/autoTrsaccUpdateReq"),
      children: [
        {
          path: "autoTrsaccUpdateReq1",
          name: "autoTrsaccUpdateReq1",
          description: "자동이체변경step1",
          component: () => import("@/views/templates/transfer/autoTrsaccUpdateReq1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "autoTrsaccUpdateReq2",
          name: "autoTrsaccUpdateReq2",
          description: "자동이체변경step2",
          component: () => import("@/views/templates/transfer/autoTrsaccUpdateReq2"),
          meta: {
            roles: ["login"],
            step: 2,
            transparent: true,
          },
        },
        {
          path: "autoTrsaccUpdateReq3",
          name: "autoTrsaccUpdateReq3",
          description: "자동이체변경step3",
          component: () => import("@/views/templates/transfer/autoTrsaccUpdateReq3"),
          meta: {
            roles: ["login"],
            step: 3,
            transparent: true,
          },
        },
      ],
    },
    {
      path: "trsaccRsultInq",
      name: "trsaccRsultInq",
      description: "이체결과조회",
      component: () => import("@/views/templates/transfer/trsaccRsultInq"),
      meta: {
        roles: ["login"],
      },
    },
    {
      path: "cbmnetTrsaccRsultInq",
      name: "cbmnetTrsaccRsultInq",
      description: "이체결과조회(CBM-NET2)",
      component: () => import("@/views/templates/transfer/cbmnetTrsaccRsultInq"),
      meta: {
        roles: ["login"],
      },
    },
    {
      path: "cbmnetTrsaccInfoInptReq",
      name: "cbmnetTrsaccInfoInptReq",
      redirect: { name: "cbmnetTrsaccInfoInptReqStep1" },
      component: () => import("@/views/templates/transfer/cbmnetTrsaccInfoInptReq"),
      children: [
        {
          path: "cbmnetTrsaccInfoInptReqStep1",
          name: "cbmnetTrsaccInfoInptReqStep1",
          component: () => import("@/views/templates/transfer/cbmnetTrsaccInfoInptReqStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "cbmnetTrsaccInfoInptReqStep2",
          name: "cbmnetTrsaccInfoInptReqStep2",
          component: () => import("@/views/templates/transfer/cbmnetTrsaccInfoInptReqStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "cbmnetTrsaccInfoInptReqStep3",
          name: "cbmnetTrsaccInfoInptReqStep3",
          component: () => import("@/views/templates/transfer/cbmnetTrsaccInfoInptReqStep3"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "cbmnetTrsaccInfoInptReqStep4",
          name: "cbmnetTrsaccInfoInptReqStep4",
          component: () => import("@/views/templates/transfer/cbmnetTrsaccInfoInptReqStep4"),
          meta: {
            roles: ["login"],
            firstPage: "cbmnetTrsaccInfoInptReqStep1",
            step: 4,
          },
        },
        {
          path: "cbmnetTrsaccInfoInptReqStep5",
          name: "cbmnetTrsaccInfoInptReqStep5",
          component: () => import("@/views/templates/transfer/cbmnetTrsaccInfoInptReqStep5"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "approvalComplete",
          name: "cbmnetTrsaccInfoInptApprovalComplete",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "fcTrsaccRsultInq",
      name: "fcTrsaccRsultInq",
      description: "외화이체신청내역조회",
      component: () => import("@/views/templates/transfer/fcTrsaccRsultInq"),
      meta: {
        roles: ["login"],
      },
    },
    {
      path: "mmrSalaryApplyRsultInq",
      name: "mmrSalaryApplyRsultInq",
      description: "급여이체 결과조회",
      component: () => import("@/views/templates/transfer/mmrSalaryApplyRsultInq"),
      meta: {
        roles: ["login", "corp"],
      },
    },
    {
      path: "mmQR",
      name: "mmQR",
      redirect: { name: "mmQrPaymentStep1" },
      component: () => import("@/views/templates/transfer/mmQr"),
      children: [
        {
          path: "mmQrPaymentStep1",
          name: "mmQrPaymentStep1",
          description: "MMQR Payment Step1",
          component: () => import("@/views/templates/transfer/mmQrPaymentStep1"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 1,
          },
        },
        {
          path: "mmQrPaymentStep2",
          name: "mmQrPaymentStep2",
          description: "MMQR Payment Step2",
          component: () => import("@/views/templates/transfer/mmQrPaymentStep2"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 2,
          },
        },
        {
          path: "mmQrPaymentStep3",
          name: "mmQrPaymentStep3",
          description: "MMQR Payment Step3",
          component: () => import("@/views/templates/transfer/mmQrPaymentStep3"),
          meta: {
            roles: ["login"],
            goback: false,
            menu:false,
            transparent: true,
            step: 3,
          },
        },
        {
          path: "mmQrPaymentStep4",
          name: "mmQrPaymentStep4",
          description: "MMQR Payment Step4",
          component: () => import("@/views/templates/transfer/mmQrPaymentStep4"),
          meta: {
            roles: ["login"],
            transparent: true,
            step: 4,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "mmQrPaymentHist",
      name: "mmQrPaymentHist",
      description: "MMQR Payment History",
      component: () => import("@/views/templates/transfer/mmQrPaymentHist"),
      meta: {
        roles: ["login"],
      },
    },
    {
      path: "mmQRAgreeTermsConditions",
      name: "mmQRAgreeTermsConditions",
      description: "mmQR약관동의",
      component: () => import("@/views/templates/transfer/mmQRAgreeTermsConditions"),
      meta: {
        roles: ["login"],
        transparent: true,
      },
    },
    {
      path: "mmQRServiceJoinProcessing",
      name: "mmQRServiceJoinProcessing",
      description: "mmQR미가입화면",
      component: () => import("@/views/templates/transfer/mmQRServiceJoinProcessing"),
      meta: {
        roles: ["login"],
        transparent: true,
      },
    },
    {
      path: "mmQRServiceJoinFailed",
      name: "mmQRServiceJoinFailed",
      description: "mmQR가입실패화면",
      component: () => import("@/views/templates/transfer/mmQRServiceJoinFailed"),
      meta: {
        roles: ["login"],
        transparent: true,
      },
    },
  ],
};

export default transfer;
